<script setup>
useHead({
  title: "VimiCrypto Terms of Service",
});

definePageMeta({
  layout: "simplified",
});
</script>
<template>
  <UMain>
    <UPage>
      <UPageHeader
        title="Terms of Service"
        description="Last updated: 21.02.2024" />

      <UPageBody prose>
        <div class="py-5">
          Please read this Terms of Service Agreement carefully before start
          using VimiCrypto. VimiCrypto is a crypto management platform which
          consists of www.vimicrypto.com and all corresponding domains,
          subdomains, web pages and associated applications (hereafter
          “VimiCrypto” or the “Site”) offered to you by Vimi Pussewala Hewage
          (hereafter “Vimi”, “We”, “us” or “our”) which offers internet-based
          solutions for customers especially within the crypto market. The
          company is registered in Brønnøysundregistrene in Norway with the
          organization no. 929487125 and located in the address Blakstadmarka
          26, 1386 Asker, Norway. Upon using VimiCrypto, creating an account, or
          using any other services, you (hereafter “you”, “your”, “yours” or
          “yourself”) agree to accept and to comply with the Terms of Service as
          stated below.
        </div>

        <h1 class="text-2xl">Changes to the Terms of Service</h1>
        <p class="pb-5">
          We may change these Terms of Service time to time. If you continue to
          use VimiCrypto after we post changes to these Terms of Service, you
          are compelled to accept of the new terms. By reloading this page, you
          can view the latest version of the Terms of Service at any instance.
        </p>

        <h1 class="text-2xl">Use of Service</h1>
        <p class="pb-5">
          VimiCrypto will only permit registered customers who have created a
          user account to register their crypto currency trades in different
          exchanges. If you do not accept these terms, do not create an account.
          To fully use VimiCrypto, it is essential to create your account with
          information, such as your name, valid email, password, and a
          two-factor authentication. You are responsible for all activity that
          occurs in association with your account. We are not liable for any
          losses or damages caused by failures at your end to maintain the
          confidentiality of your account credentials. Please contact us, if you
          discover or suspect any security breach related to VimiCrypto or your
          account. It is your responsibility to follow the rules and laws in
          your country of residence and/or country from which you access
          VimiCrypto site.
        </p>

        <h1 class="text-2xl">Creating an account</h1>
        <p class="pb-5">
          By registering with VimiCrypto, you agree to provide us with current,
          accurate and complete information about yourself, and to keep such
          information updated in your profile. You further agree that you will
          not use any account other than your own or access the account of any
          other customer at any time or assist any others in obtaining
          unauthorized access. You are authorized to access only the functions
          in the system that are relevant to your subscription.
        </p>

        <h1 class="text-2xl">Maintaining your account</h1>
        <p class="pb-5">
          You are abide to maintain the confidentiality throughout your customer
          relationship with VimiCrypto as mentioned above, of your account
          information, by including a strong password to safeguard your records
          posted to your account. Any operation you initiate from your account
          or using your password, two-factor authentication will be considered
          made by you, and you are solely responsible for those operations once
          validated using your password or made through your account. You are
          required to notify VimiCrypto immediately regarding any unauthorized
          use of your account or password, or any breach of security, by an
          email to support@viminorge.com
        </p>

        <h1 class="text-2xl">Termination and deletion of Accounts</h1>
        <p class="pb-5">
          Vimi, at sole discretion, may terminate your access to the site and to
          your account. This may include supension or termination of the service
          and customer accounts, or prohibit access to the site and its content,
          services, and tools. If Vimi has reason to believe that such customers
          are causing problems or creating potential legal liabilities,
          violation of third-party intellectual property rights or acting
          against the Terms of Service, we may take technical and legal steps to
          keep such customers out of the site. Additionally, VimiCrypto in
          appropriate circumstances, may suspend or terminate customer accounts
          for any reason, including without limitation:
        </p>

        <ul class="px-5 list-disc">
          <li>
            Trying to gain unauthorized access to the site or another customers
            account
          </li>
          <li>
            Attempting to circumvent software security features that limit use
            of or access the site or that protect its content
          </li>
          <li>Using the site to engage in an illegal activity</li>
          <li>Failing to comply with the Terms of Service</li>
          <li>Failing to pay the subscription fees</li>
          <li>
            To comply with a request from law enforcement or other government
            agencies
          </li>
        </ul>

        <p class="pb-5">
          If your account remain inactive for more than one year, Vimi reserve
          the right to terminate the account. Accounts may only be transferred
          in the event of the account holder’s death.
        </p>

        <h1 class="text-2xl">Payment and cancellation of service</h1>
        <p class="pb-3">
          By creating an account on VimiCrypto, you confirm that you have
          accepted our Terms of Service, and privacy policy. By upgrading the
          free account to a paid subscription, you authorize Vimi to
          automatically charge your bank card or PayPal account according to the
          billing period selected by you. There are no refunds on monthly plans.
          Refunds are available only after an automatic deduction for annual
          payments within 14 calendar days after the payment was made. The
          service is billed in advance on a monthly or annual basis. If
          automatic renewal fails for a subscription, it is your responsibility
          to provide correct payment details in the Billing portal to resume
          renewal process. Failing to do so may lead to a termination of your
          user account.
        </p>
        <p class="pb-3">
          All billing is recurring, which means you will continue to get billed
          until you cancel your subscription. Cancelling your subscription is
          sole responsibility of yours. You may cancel your subscription at any
          time by visiting the billing section of your profile.
        </p>
        <p class="pb-5">
          If you cancel the service before the end of your current paid up
          period, your subscription will remain active until the next due date.
          After the due date, your subscription will be expired.
        </p>

        <h1 class="text-2xl">Intellectual Property Rights</h1>
        <p class="pb-3">
          All materials on the VimiCrypto site are sole property of Vimi and are
          protected by copyright, trademark, and other applicable laws, unless
          otherwise specified. Materials that you download or print for
          personal, informational, or non-commercial use are permitted, with the
          stipulation that you comply with the copyright and proprietary laws.
        </p>
        <p class="pb-3">
          The trademarks and logos used on the VimiCrypto site ("trademarks")
          are the property of Vimi. This includes, for example, software,
          images, titles, text, graphics, data, prices, charts, graphs, video
          and audio that are used on the site.
        </p>
        <p class="pb-3">
          Any unauthorised use of trademarks or material may violate copyright,
          trademark and other applicable laws and could result in criminal or
          civil penalties. This includes copying, reproducing, changing,
          republishing, uploading, posting, distributing, collecting,
          transmitting, or scraping in any manual or automated form.
        </p>

        <h1 class="text-2xl">Availability of the Service</h1>
        <p class="pb-3">
          Vimi offers no warranty of any kind. We cannot guarantee that
          VimiCrypto site will be available 100% of the time to meet your needs.
          However, we will strive to provide uninterrupted service, and where
          that is not possible, will aim to provide it as soon as possible.
          Despite best efforts, it is possible that service may be interrupted,
          and it is possible that there may be delays, failures, errors,
          omissions, or loss of transmitted information.
        </p>
        <p class="pb-3">
          In accordance with the Terms of Service, Vimi will try to ensure that
          the VimiCrypto site can be accessed by you. However, Vimi may suspend
          use of the site for maintenance and will make reasonable efforts to
          give you prior notice on such. In critical or emergency situations,
          Vimi may be unable to provide this notification; thus you are
          acknowledged on the risks associated with such failures in accessing
          the site or carrying out operations using your account.
        </p>
        <p class="pb-3">
          Vimi will make reasonable efforts to fulfil all trades you create
          using third-party integrations, but in some circumstances, Vimi may be
          unable to. If this is the case, it could be that the third-party
          integration provider has changed their services or has failed to
          provide the services needed. You can retry the operations later and if
          not succeed in doing so, please contact Vimi support at
          support@viminorge.com
        </p>
        <p class="pb-3">
          Vimi might be unable to perform certain services due to factors beyond
          our control, including but not limited to failure of the hardware,
          software or other infrastructure used by VimiCrypto, internet
          connection or other technical breakdowns. In these circumstances, Vimi
          will make reasonable efforts to restore the service at our earliest
          possible.
        </p>
        <p class="pb-3">
          Vimi may suspend, terminate, or modify the service as deemed necessary
          by Vimi due to changes in applicable law, sanctions, policy, required
          repairs, maintenance, upgrades and/or replacement of the software,
          hardware and/or other infrastructure used by Vimi, updating of the
          Vimi internal procedures and the like. Vimi shall not be liable to the
          customer in such events.
        </p>
        <p class="pb-5">
          Although Vimi try its best to provide accurate and timely information,
          Vimi services may contain inaccuracies, incomplete or outdated
          information, or errors. Vimi may change or update any and all Vimi
          services at any time without notice, and you should independently
          verify all information before making decisions or taking action.
        </p>

        <h1 class="text-2xl">External third-party APIs</h1>
        <p class="pb-5">
          VimiCrypto website has third-party API integrations such as Binance.
          These external APIs are not within the control of Vimi; therefore,
          Vimi assume no responsibility or liability for the content presented
          via these external APIs.
        </p>

        <h1 class="text-2xl">Financial Advice</h1>
        <p class="pb-3">
          Vimi do not provide any investment advice with regard to the use of
          VimiCrypto website.
        </p>
        <p class="pb-5">
          VimiCrypto may provide information on the live market price, charts of
          digital currencies that are available on your trade list and events
          that have affected the price of such digital assets/currencies, but
          this shall neither be considered as investment advice, nor should it
          be construed as such.
        </p>

        <h1 class="text-2xl">Taxes</h1>
        <p class="pb-5">
          You are responsible for determining what taxation applies to you with
          regard to your assets to be in compliance with the relevant tax
          authority in your jurisdiction. Vimi will not be responsible for
          assessing, collecting, reporting, withholding, or remitting any taxes
          on your behalf as a result of your trades, and likewise offers no
          tax-related advice or information.
        </p>

        <h1 class="text-2xl">Communication</h1>
        <p class="pb-3">
          Upon your consent, Vimi may use e-mail as a general communication
          channel with you.
        </p>
        <p class="pb-3">
          If you are sending personal information, Vimi recommend that you send
          e-mail in an encrypted format. Unencrypted e-mail is not secure and
          Vimi are not responsible for any damages incurred by sending unsecured
          e-mail.
        </p>
        <p class="pb-5">
          If you send unencrypted or unsecured e-mail or other types of
          communications, Vimi may respond using the same channels; therefore,
          you assume all the risk associated with this.
        </p>

        <h1 class="text-2xl">Privacy Policy</h1>
        <p class="pb-3">
          For information about our handling of personal data, please see our
          Privacy Policy. By agreeing to the Terms of Service, you agree that
          Vimi can collect and use your information in accordance with the
          Privacy Policy.
        </p>

        <h1 class="text-2xl">Disclaimer</h1>
        <p class="pb-5">
          The content of VimiCrypto and/or data are provided “as is”, without
          warranty of any kind. Without limiting the foregoing, Vimi explicitly
          disclaim all express or implied warranties arising out of or related
          to these terms, including implied warranties of merchantability,
          fitness for a particular purpose, and non-infringement. Vimi make no
          warranty that the VimiCrypto will meet your requirements or be
          available on an uninterrupted, secure, or error-free basis. We make no
          warranty regarding the quality, accuracy, timeliness, truthfulness,
          completeness, or reliability of VimiCrypto.
        </p>

        <h1 class="text-2xl">Contact</h1>
        <p class="pb-5">
          If you have any questions regarding these Terms of Services or your
          use of VimiCrypto site, your account or any other matter, please
          contact support@viminorge.com
        </p>
      </UPageBody>
    </UPage>
  </UMain>
</template>

<style lang="scss" scoped></style>
